import React from 'react';
import styled from 'styled-components';
import { List } from '../List/List.js';

const StyledNav = styled.nav `
  li {
    justify-content: ${({ align }) => align};
  }
  text-align: ${({ align }) => align};
`;
const Navigation = ({ children, direction, spacing, spaceAfter, align, className }) => {
    return (React.createElement(StyledNav, { align: align, className: className },
        React.createElement(List, { direction: direction, spaceBetween: spacing, spaceAfter: spaceAfter }, children)));
};
Navigation.defaultProps = {
    align: 'left',
};

export { Navigation };
//# sourceMappingURL=Navigation.js.map
